import { useState } from "react";
import { Chip, FormControl, InputLabel, MenuItem, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Select, { SelectProps } from "@mui/material/Select";
import { BRIEFDAYS, DAYS } from "Constants/App";
import MenuButton from "../Pages/Home/Toolbox/Button";

interface IProps extends SelectProps {
  setData: (value: []) => void;
  activeDays?: number[];
  padding?: string;
  isGeneral?: boolean;
  minWidth?: number;
}

export default function DayPicker(props: IProps) {
  const { setData, label, padding, activeDays, isGeneral, minWidth } = props;
  const [days, setDays] = useState<any[]>(() => []);

  const showDays = activeDays ? BRIEFDAYS.filter((d) => activeDays.includes(d.id)) : BRIEFDAYS;

  const handleFormat = (event: React.MouseEvent<HTMLElement>, newDays: []) => {
    setDays(newDays);
    setData(newDays);
  };

  return (
    <Stack>
      {/* <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <Select {...props} onChange={handleChange}>
        {newDays.map((day) => (
          <MenuItem key={day.id} value={day.id}>
            {day.name}
          </MenuItem>
        ))}
      </Select> */}
      <ToggleButtonGroup value={days} onChange={handleFormat} aria-label="text formatting">
        {BRIEFDAYS.map((day) => (
          <ToggleButton
            value={day.id}
            key={day.id}
            disabled={activeDays ? !activeDays.includes(day.id) : !isGeneral}
            style={{
              backgroundColor: days.includes(day.id) ? "#4754CA" : "",
              color: days.includes(day.id) ? "#fff" : "",
              padding,
              minWidth,
            }}
          >
            {day.name}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
}
